import { render, staticRenderFns } from "./IA4.vue?vue&type=template&id=85c76b70&"
import script from "./IA4.vue?vue&type=script&lang=js&"
export * from "./IA4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports